export const deactivateRcsTemplatesMutation = (builder) => ({
  deactivateRcsTemplates: builder.mutation({
    query: ({ template = "" }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/deactivate_rcs_template",
        method: "GET",
        params: { template },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
